export default {"src":"/_next/static/media/verified.e2cac710.svg","height":28,"width":28};